import type { PublicKeyCredentialRequestOptionsJSON } from "@simplewebauthn/server";
import { z } from "zod";

export default {
  params: z.object({
    accountId: z.string(),
    beneficiaryId: z.number(),
    amount: z.number(),
  }),
  response: z.object({
    webAuthnAuthenticationOptions: z.custom<PublicKeyCredentialRequestOptionsJSON>(),
  }),
};
